

















































import { Component, Vue } from "vue-property-decorator";
import HistoryCard from "@/components/geschiedenis/HistoryCard.vue";

@Component({
    components: { HistoryCard }
})
export default class History extends Vue {
    /**
     * Images
     */
    images = {
        begin: require("@/assets/img/geschiedenis/begin.png?size=300"),
        naamgeving: require("@/assets/img/geschiedenis/naamgeving.png?size=300")
    };
}
